import { i18nPrice } from '@shared/fondof-fn/format/price'
import { parseAmount, parsePartialAmount } from '@shared/fondof-fn/parse/amount'
import { isValue } from '@shared/fondof-fn/validation/value'
import type {
  CartCostFragment,
  CartLineCostFragment,
} from '@shared/types/storefront/graphql'

export const toCartCost = (cost: CartCostFragment) => {
  const checkoutChargeAmount = parseAmount(cost.checkoutChargeAmount.amount)
  const totalAmount = parseAmount(cost.totalAmount.amount)
  const subtotalAmount = parseAmount(cost.subtotalAmount.amount)

  return {
    checkoutChargeAmountParsed: i18nPrice(
      checkoutChargeAmount,
      cost.checkoutChargeAmount.currencyCode
    ),
    checkoutChargeAmount,

    subtotalAmountParsed: i18nPrice(
      subtotalAmount,
      cost.subtotalAmount.currencyCode
    ),
    subtotalAmount,
    subtotalAmountEstimated: cost.subtotalAmountEstimated,

    totalAmountParsed: i18nPrice(totalAmount, cost.totalAmount.currencyCode),
    totalAmount,
    totalAmountEstimated: cost.totalAmountEstimated,

    currencyCode:
      cost.totalAmount.currencyCode ??
      cost.subtotalAmount.currencyCode ??
      cost.checkoutChargeAmount.currencyCode ??
      undefined,
  }
}

export const toItemCost = (cost: CartLineCostFragment, quantity: number) => {
  const subtotalAmount = parseAmount(cost.subtotalAmount.amount)
  const totalAmount = parseAmount(cost.totalAmount.amount)
  const amountPerQuantity = parseAmount(cost.amountPerQuantity.amount)
  const compareAtAmountPerQuantity = parsePartialAmount(
    cost.compareAtAmountPerQuantity?.amount
  )

  const originalPrice = isValue(compareAtAmountPerQuantity)
    ? compareAtAmountPerQuantity
    : cost.subtotalAmount.amount / quantity
  const price = isValue(compareAtAmountPerQuantity)
    ? amountPerQuantity
    : cost.totalAmount.amount / quantity

  const discountAmount = originalPrice - price
  const isOffer = discountAmount > 0

  return {
    originalPrice,
    originalPriceParsed: i18nPrice(
      originalPrice,
      cost.subtotalAmount.currencyCode
    ),
    price,
    priceParsed: i18nPrice(price, cost.totalAmount.currencyCode),

    amountPerQuantityParsed: i18nPrice(
      amountPerQuantity,
      cost.amountPerQuantity.currencyCode
    ),
    amountPerQuantity,

    compareAtAmountPerQuantityParsed: compareAtAmountPerQuantity
      ? i18nPrice(
          compareAtAmountPerQuantity,
          cost.compareAtAmountPerQuantity?.currencyCode ??
            cost.amountPerQuantity.currencyCode
        )
      : undefined,
    compareAtAmountPerQuantity,

    subtotalAmountParsed: i18nPrice(
      subtotalAmount,
      cost.subtotalAmount.currencyCode
    ),
    subtotalAmount,

    discountAmountParsed: i18nPrice(
      discountAmount,
      cost.totalAmount.currencyCode
    ),
    discountAmount,
    isOffer,

    totalAmountParsed: i18nPrice(totalAmount, cost.totalAmount.currencyCode),
    totalAmount,

    currencyCode:
      cost.totalAmount.currencyCode ??
      cost.subtotalAmount.currencyCode ??
      cost.amountPerQuantity.currencyCode ??
      cost.compareAtAmountPerQuantity?.currencyCode ??
      undefined,
  }
}
